export enum ColorSelectorWidgetID {
    PALETTES = "palettes",
    HEX = "hex",
    RGB = "rgb"
}
